import { IErroBoundaryContext } from "@app/app/types";
import * as React from "react";

export const ErrorBoundaryContext = React.createContext<IErroBoundaryContext>({} as IErroBoundaryContext);

ErrorBoundaryContext.displayName = "ErrorBoundaryContext";
